import MainTableApplication from '../../components/MainTableApplications/MainTableApplication'

const Applications = () => {

    return(
        <MainTableApplication type='applications' />
    )

}



export default Applications